import InvoiceAdjustmentForm from "@app/components/forms/invoice/invoice-adjustment-form.tsx";
import { PageContainer } from "@app/components/page-container.tsx";
import { createFileRoute } from "@tanstack/react-router";

interface SearchParams {
    from?: string;
}

export const Route = createFileRoute("/_authenticated/_manager/invoice/$invoiceId/adjustment/create")({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown>): SearchParams => ({
        from: search.from as string | undefined,
    }),
});

function RouteComponent() {
    const { from } = Route.useSearch();
    const { invoiceId } = Route.useParams();

    return (
        <PageContainer title={"Create Adjustment"} from={from}>
            <InvoiceAdjustmentForm invoiceId={+invoiceId} from={from} />
        </PageContainer>
    );
}
